export enum Mode {
  Otg = 1,
  Usb = 2,
}

export enum DeviceStatus {
  Init = 0,
  OpTooFrequent = 1,
  Login = 2,
  Captcha = 4,
  AccountException = 8,
  Exception = 16,
  AccountRest = 32,
  Task = 64,
  NeedClearData = 128,
  AccountRestricted = 1 << 8,
}

export enum DataSource {
  RedBook = 1,
  Sph = 2,
  TikTok = 3,
  Wechat = 4,
  Douyin = 5,
  Mail = 12,
  Boss = 14,
  Qiwei = 16,
  Qianniu = 17,
  WechatOfficialAccount = 18,
  RedBookGroup = 19,
}

export type SimInfo = {
  iccid?: string
  internalId?: string
  realId?: string
  officialReal?: boolean
  totalFlow?: string
  usedFlow?: string
}

export interface DeviceLoginApp {
  appName: string
  dataSource: number
  accountId: string
  accountName: string
  avatar: string
  isLogin: boolean
}

export interface DigitalEmployee {
  id: string
  serialNumber: string
  name: string
  remark?: string
  wssHost?: string
  createdAt?: number | string
  updatedAt?: number | string
  isLogin: boolean
  loginApps: DeviceLoginApp[]
  type: number
  mode: Mode | null
  available: boolean
  status: DeviceStatus
  expiredAt?: number | string | null
  tags: string[]
  phoneScreenshotSrc: string
  wss?: string
  simInfo?: SimInfo
}

export interface DigitalEmployeeCreatePayload {
  tags?: string[]
  serial_number?: string
  remark?: string
  available?: boolean
  area_id?: string
  device_mode?: number
}

export type MatrixDeviceAdminItem = {
  id: string
  serial_number?: string
  remark?: string
  wss_host?: string
  wssHost?: string
  wss?: string
  created_at?: number
  updated_at?: number
  available?: boolean
  is_login?: boolean
  login_apps?: Array<{
    app_name?: string
    data_source?: number
    account_id?: string
    account_name?: string
    avatar?: string
    is_login?: boolean
  }>
  status?: number
  type?: number
  tags?: string
  mode?: number
  expired_at?: number | string | null
  sim_info?: {
    iccid?: string
    internal_id?: string
    real_id?: string
    official_real?: boolean
    total_flow?: string
    used_flow?: string
  }
}
